"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZEnumValuesValueTypes_Regions = exports.ZEnumValuesValueTypes_Properties = exports.ZEnumValuesValueTypes_Blocks = exports.ZEnumValuesValueTypes_IrrigationZones = exports.ZEnumValuesValueTypes_Points = exports.ZEnumValuesValueTypes_HeatmapPoints = void 0;
// WARNING: This file is auto-generated. Do not edit this file directly.
const zod_1 = require("zod");
exports.ZEnumValuesValueTypes_HeatmapPoints = zod_1.z.enum(['temperature_IN']);
exports.ZEnumValuesValueTypes_Points = zod_1.z.enum([
    'chillCumulativeHoursBelow45FMAR',
    'chillCumulativeHoursBelow45FMAY',
    'chillCumulativeHoursBelow45FNOV',
    'chillCumulativeHoursBelow45FSEP',
    'chillCumulativeHoursBetween32and45FMAR',
    'chillCumulativeHoursBetween32and45FMAY',
    'chillCumulativeHoursBetween32and45FNOV',
    'chillCumulativeHoursBetween32and45FSEP',
    'chillCumulativePortionsMAR',
    'chillCumulativePortionsMAY',
    'chillCumulativePortionsNOV',
    'chillCumulativePortionsSEP',
    'chillHoursBelow45F',
    'chillHoursBetween32and45F',
    'chillPortions',
    'dewDifferential_ABOVE',
    'dewDifferential_BELOW',
    'dewDifferential_IN',
    'dewPoint_ABOVE',
    'dewPoint_BELOW',
    'dewPoint_IN',
    'fruitGrowth',
    'fruitSize',
    'fruitSizeTarget',
    'humidity_ABOVE',
    'humidity_BELOW',
    'humidity_IN',
    'insectLarvalTrend_1',
    'insectLarvalTrend_2',
    'insectLarvalTrend_6',
    'insectLarvalTrend_7',
    'insectLarvalTrend_9',
    'insectLarvalTrend_11',
    'insectLarvalTrend_20',
    'insectTrapCatches_1',
    'insectTrapCatches_2',
    'insectTrapCatches_6',
    'insectTrapCatches_7',
    'insectTrapCatches_9',
    'insectTrapCatches_10',
    'insectTrapCatches_11',
    'insectTrapCatches_12',
    'insectTrapCatches_15',
    'insectTrapCatches_16',
    'insectTrapCatches_17',
    'insectTrapCatches_19',
    'insectTrapCatches_20',
    'insectTrapCatches_25',
    'insectTrapCatches_27',
    'insectTrapCatches_28',
    'insectTrapCatches_29',
    'insectTrapCatches_30',
    'irrigationActivityIntervalsSemios_emitterBuriedDrip1',
    'irrigationActivityIntervalsSemios_emitterBuriedDrip2',
    'irrigationActivityIntervalsSemios_emitterDrip1',
    'irrigationActivityIntervalsSemios_emitterDrip2',
    'irrigationActivityIntervalsSemios_emitterFloodFurrow',
    'irrigationActivityIntervalsSemios_emitterMicrospray',
    'irrigationActivityIntervalsSemios_emitterOther',
    'irrigationActivityIntervalsSemios_emitterOverheadCoolingMicrospray',
    'irrigationActivityIntervalsSemios_emitterOverheadCoolingSprinkler',
    'irrigationActivityIntervalsSemios_emitterSprinkler',
    'irrigationActivityIntervalsSemios_postFilter',
    'irrigationActivityIntervalsSemios_preFilter',
    'irrigationActivityIntervalsSemios_pump',
    'irrigationActivityIntervalsSemios_systemPressure',
    'irrigationFlowMeter',
    'irrigationFlowRate',
    'irrigationPressureSemios_emitterBuriedDrip1',
    'irrigationPressureSemios_emitterBuriedDrip2',
    'irrigationPressureSemios_emitterDrip1',
    'irrigationPressureSemios_emitterDrip2',
    'irrigationPressureSemios_emitterFloodFurrow',
    'irrigationPressureSemios_emitterMicrospray',
    'irrigationPressureSemios_emitterOther',
    'irrigationPressureSemios_emitterOverheadCoolingMicrospray',
    'irrigationPressureSemios_emitterOverheadCoolingSprinkler',
    'irrigationPressureSemios_emitterSprinkler',
    'irrigationPressureSemios_postFilter',
    'irrigationPressureSemios_preFilter',
    'irrigationPressureSemios_pump',
    'irrigationPressureSemios_systemPressure',
    'irrigationVolumeDurationSemios_emitterBuriedDrip1',
    'irrigationVolumeDurationSemios_emitterBuriedDrip2',
    'irrigationVolumeDurationSemios_emitterDrip1',
    'irrigationVolumeDurationSemios_emitterDrip2',
    'irrigationVolumeDurationSemios_emitterFloodFurrow',
    'irrigationVolumeDurationSemios_emitterMicrospray',
    'irrigationVolumeDurationSemios_emitterOther',
    'irrigationVolumeDurationSemios_emitterOverheadCoolingMicrospray',
    'irrigationVolumeDurationSemios_emitterOverheadCoolingSprinkler',
    'irrigationVolumeDurationSemios_emitterSprinkler',
    'irrigationVolumeDurationSemios_postFilter',
    'irrigationVolumeDurationSemios_preFilter',
    'irrigationVolumeDurationSemios_pump',
    'irrigationVolumeDurationSemios_systemPressure',
    'leafWetnessHours',
    'precipitation',
    'signalTS5',
    'soilIonicContent',
    'soilMoisture',
    'soilTemperature',
    'soilVwc',
    'sunrise',
    'sunset',
    'temperature_ABOVE',
    'temperature_BELOW',
    'temperature_IN',
    'temperatureInversion_ABOVEvsBELOW',
    'temperatureInversion_ABOVEvsIN',
    'trunkDisplacement',
    'weatherIcon',
    'wetBulb_ABOVE',
    'wetBulb_BELOW',
    'wetBulb_IN',
    'windDirection',
    'windMachineActivity',
    'windMachineActivityIntervals',
    'windMachineBattery',
    'windMachineCycles',
    'windMachineFuel',
    'windMachineRPM',
    'windMachineRunTime',
    'windMachineSettings',
    'windMachineTemperature',
    'windSpeed',
]);
exports.ZEnumValuesValueTypes_IrrigationZones = zod_1.z.enum([
    'irrigationActivityIntervalsSemios_emitterBuriedDrip1',
    'irrigationActivityIntervalsSemios_emitterBuriedDrip2',
    'irrigationActivityIntervalsSemios_emitterDrip1',
    'irrigationActivityIntervalsSemios_emitterDrip2',
    'irrigationActivityIntervalsSemios_emitterFloodFurrow',
    'irrigationActivityIntervalsSemios_emitterMicrospray',
    'irrigationActivityIntervalsSemios_emitterOther',
    'irrigationActivityIntervalsSemios_emitterOverheadCoolingMicrospray',
    'irrigationActivityIntervalsSemios_emitterOverheadCoolingSprinkler',
    'irrigationActivityIntervalsSemios_emitterSprinkler',
    'irrigationActivityIntervalsSemios_postFilter',
    'irrigationActivityIntervalsSemios_preFilter',
    'irrigationActivityIntervalsSemios_pump',
    'irrigationActivityIntervalsSemios_systemPressure',
    'irrigationActivityPlannedIntervalsSemios_emitterBuriedDrip1',
    'irrigationActivityPlannedIntervalsSemios_emitterBuriedDrip2',
    'irrigationActivityPlannedIntervalsSemios_emitterDrip1',
    'irrigationActivityPlannedIntervalsSemios_emitterDrip2',
    'irrigationActivityPlannedIntervalsSemios_emitterFloodFurrow',
    'irrigationActivityPlannedIntervalsSemios_emitterMicrospray',
    'irrigationActivityPlannedIntervalsSemios_emitterOther',
    'irrigationActivityPlannedIntervalsSemios_emitterOverheadCoolingMicrospray',
    'irrigationActivityPlannedIntervalsSemios_emitterOverheadCoolingSprinkler',
    'irrigationActivityPlannedIntervalsSemios_emitterSprinkler',
    'irrigationActivityPlannedIntervalsSemios_postFilter',
    'irrigationActivityPlannedIntervalsSemios_preFilter',
    'irrigationActivityPlannedIntervalsSemios_pump',
    'irrigationActivityPlannedIntervalsSemios_systemPressure',
    'irrigationPlannedVolumeDurationSemios_emitterBuriedDrip1',
    'irrigationPlannedVolumeDurationSemios_emitterBuriedDrip2',
    'irrigationPlannedVolumeDurationSemios_emitterDrip1',
    'irrigationPlannedVolumeDurationSemios_emitterDrip2',
    'irrigationPlannedVolumeDurationSemios_emitterFloodFurrow',
    'irrigationPlannedVolumeDurationSemios_emitterMicrospray',
    'irrigationPlannedVolumeDurationSemios_emitterOther',
    'irrigationPlannedVolumeDurationSemios_emitterOverheadCoolingMicrospray',
    'irrigationPlannedVolumeDurationSemios_emitterOverheadCoolingSprinkler',
    'irrigationPlannedVolumeDurationSemios_emitterSprinkler',
    'irrigationPlannedVolumeDurationSemios_postFilter',
    'irrigationPlannedVolumeDurationSemios_preFilter',
    'irrigationPlannedVolumeDurationSemios_pump',
    'irrigationPlannedVolumeDurationSemios_systemPressure',
    'irrigationVolumeDurationSemios_emitterBuriedDrip1',
    'irrigationVolumeDurationSemios_emitterBuriedDrip2',
    'irrigationVolumeDurationSemios_emitterDrip1',
    'irrigationVolumeDurationSemios_emitterDrip2',
    'irrigationVolumeDurationSemios_emitterFloodFurrow',
    'irrigationVolumeDurationSemios_emitterMicrospray',
    'irrigationVolumeDurationSemios_emitterOther',
    'irrigationVolumeDurationSemios_emitterOverheadCoolingMicrospray',
    'irrigationVolumeDurationSemios_emitterOverheadCoolingSprinkler',
    'irrigationVolumeDurationSemios_emitterSprinkler',
    'irrigationVolumeDurationSemios_postFilter',
    'irrigationVolumeDurationSemios_preFilter',
    'irrigationVolumeDurationSemios_pump',
    'irrigationVolumeDurationSemios_systemPressure',
]);
exports.ZEnumValuesValueTypes_Blocks = zod_1.z.enum([
    'almondBloom',
    'almondHullSplit',
    'alternaria',
    'alternariaCumulativeRolling7Days',
    'beeHours',
    'cherryPowderyMildewModelPredictedRisk',
    'cropDegreeDaysCumulativeSinceBiofix_3',
    'cropDegreeDaysCumulativeSinceBiofix_5',
    'cropDegreeDaysCumulativeSinceBiofix_11',
    'cropDegreeDaysCumulativeSinceBiofix_12',
    'evapotranspirationETc',
    'evapotranspirationETo',
    'evapotranspirationKc',
    'fireBlightTRV',
    'grapePowderyMildewModelPredictedRisk',
    'insectDegreeDays_1',
    'insectDegreeDays_2',
    'insectDegreeDays_3',
    'insectDegreeDays_4',
    'insectDegreeDays_6',
    'insectDegreeDays_7',
    'insectDegreeDays_8',
    'insectDegreeDays_9',
    'insectDegreeDays_10',
    'insectDegreeDays_11',
    'insectDegreeDays_12',
    'insectDegreeDays_13',
    'insectDegreeDays_14',
    'insectDegreeDays_15',
    'insectDegreeDays_16',
    'insectDegreeDays_17',
    'insectDegreeDays_18',
    'insectDegreeDays_19',
    'insectDegreeDays_20',
    'insectDegreeDays_23',
    'insectDegreeDays_24',
    'insectDegreeDays_25',
    'insectDegreeDays_26',
    'insectDegreeDays_27',
    'insectDegreeDays_28',
    'insectDegreeDays_29',
    'insectDegreeDays_30',
    'insectDegreeDaysCumulativeSinceBiofix_1',
    'insectDegreeDaysCumulativeSinceBiofix_2',
    'insectDegreeDaysCumulativeSinceBiofix_3',
    'insectDegreeDaysCumulativeSinceBiofix_4',
    'insectDegreeDaysCumulativeSinceBiofix_6',
    'insectDegreeDaysCumulativeSinceBiofix_7',
    'insectDegreeDaysCumulativeSinceBiofix_8',
    'insectDegreeDaysCumulativeSinceBiofix_9',
    'insectDegreeDaysCumulativeSinceBiofix_10',
    'insectDegreeDaysCumulativeSinceBiofix_11',
    'insectDegreeDaysCumulativeSinceBiofix_12',
    'insectDegreeDaysCumulativeSinceBiofix_13',
    'insectDegreeDaysCumulativeSinceBiofix_14',
    'insectDegreeDaysCumulativeSinceBiofix_15',
    'insectDegreeDaysCumulativeSinceBiofix_16',
    'insectDegreeDaysCumulativeSinceBiofix_17',
    'insectDegreeDaysCumulativeSinceBiofix_18',
    'insectDegreeDaysCumulativeSinceBiofix_19',
    'insectDegreeDaysCumulativeSinceBiofix_20',
    'insectDegreeDaysCumulativeSinceBiofix_23',
    'insectDegreeDaysCumulativeSinceBiofix_24',
    'insectDegreeDaysCumulativeSinceBiofix_25',
    'insectDegreeDaysCumulativeSinceBiofix_26',
    'insectDegreeDaysCumulativeSinceBiofix_27',
    'insectDegreeDaysCumulativeSinceBiofix_28',
    'insectDegreeDaysCumulativeSinceBiofix_29',
    'insectDegreeDaysCumulativeSinceBiofix_30',
    'insectLarvalTrend_1',
    'insectLarvalTrend_2',
    'insectLarvalTrend_6',
    'insectLarvalTrend_7',
    'insectLarvalTrend_9',
    'insectLarvalTrend_11',
    'insectLarvalTrend_20',
    'insectTrapCatches_1',
    'insectTrapCatches_2',
    'insectTrapCatches_6',
    'insectTrapCatches_7',
    'insectTrapCatches_9',
    'insectTrapCatches_10',
    'insectTrapCatches_11',
    'insectTrapCatches_12',
    'insectTrapCatches_15',
    'insectTrapCatches_16',
    'insectTrapCatches_17',
    'insectTrapCatches_19',
    'insectTrapCatches_20',
    'insectTrapCatches_25',
    'insectTrapCatches_27',
    'insectTrapCatches_28',
    'insectTrapCatches_29',
    'insectTrapCatches_30',
    'sprayConditions',
]);
exports.ZEnumValuesValueTypes_Properties = zod_1.z.enum([
    'almondHullSplit',
    'insectDegreeDays_1',
    'insectDegreeDays_2',
    'insectDegreeDays_3',
    'insectDegreeDays_4',
    'insectDegreeDays_6',
    'insectDegreeDays_7',
    'insectDegreeDays_8',
    'insectDegreeDays_9',
    'insectDegreeDays_10',
    'insectDegreeDays_11',
    'insectDegreeDays_12',
    'insectDegreeDays_13',
    'insectDegreeDays_14',
    'insectDegreeDays_15',
    'insectDegreeDays_16',
    'insectDegreeDays_17',
    'insectDegreeDays_18',
    'insectDegreeDays_19',
    'insectDegreeDays_20',
    'insectDegreeDays_23',
    'insectDegreeDays_24',
    'insectDegreeDays_25',
    'insectDegreeDays_26',
    'insectDegreeDays_27',
    'insectDegreeDays_28',
    'insectDegreeDays_29',
    'insectDegreeDays_30',
    'insectDegreeDaysCumulativeSinceBiofix_1',
    'insectDegreeDaysCumulativeSinceBiofix_2',
    'insectDegreeDaysCumulativeSinceBiofix_3',
    'insectDegreeDaysCumulativeSinceBiofix_4',
    'insectDegreeDaysCumulativeSinceBiofix_6',
    'insectDegreeDaysCumulativeSinceBiofix_7',
    'insectDegreeDaysCumulativeSinceBiofix_8',
    'insectDegreeDaysCumulativeSinceBiofix_9',
    'insectDegreeDaysCumulativeSinceBiofix_10',
    'insectDegreeDaysCumulativeSinceBiofix_11',
    'insectDegreeDaysCumulativeSinceBiofix_12',
    'insectDegreeDaysCumulativeSinceBiofix_13',
    'insectDegreeDaysCumulativeSinceBiofix_14',
    'insectDegreeDaysCumulativeSinceBiofix_15',
    'insectDegreeDaysCumulativeSinceBiofix_16',
    'insectDegreeDaysCumulativeSinceBiofix_17',
    'insectDegreeDaysCumulativeSinceBiofix_18',
    'insectDegreeDaysCumulativeSinceBiofix_19',
    'insectDegreeDaysCumulativeSinceBiofix_20',
    'insectDegreeDaysCumulativeSinceBiofix_23',
    'insectDegreeDaysCumulativeSinceBiofix_24',
    'insectDegreeDaysCumulativeSinceBiofix_25',
    'insectDegreeDaysCumulativeSinceBiofix_26',
    'insectDegreeDaysCumulativeSinceBiofix_27',
    'insectDegreeDaysCumulativeSinceBiofix_28',
    'insectDegreeDaysCumulativeSinceBiofix_29',
    'insectDegreeDaysCumulativeSinceBiofix_30',
    'insectPhenology_1',
    'insectPhenology_7',
    'insectPhenology_11',
    'insectTrapCatches_1',
    'insectTrapCatches_2',
    'insectTrapCatches_6',
    'insectTrapCatches_7',
    'insectTrapCatches_9',
    'insectTrapCatches_10',
    'insectTrapCatches_11',
    'insectTrapCatches_12',
    'insectTrapCatches_15',
    'insectTrapCatches_16',
    'insectTrapCatches_17',
    'insectTrapCatches_19',
    'insectTrapCatches_20',
    'insectTrapCatches_25',
    'insectTrapCatches_27',
    'insectTrapCatches_28',
    'insectTrapCatches_29',
    'insectTrapCatches_30',
]);
exports.ZEnumValuesValueTypes_Regions = zod_1.z.enum([
    'dewPoint_IN',
    'humidity_IN',
    'insectDegreeDays_1',
    'insectDegreeDays_2',
    'insectDegreeDays_3',
    'insectDegreeDays_4',
    'insectDegreeDays_6',
    'insectDegreeDays_7',
    'insectDegreeDays_8',
    'insectDegreeDays_9',
    'insectDegreeDays_10',
    'insectDegreeDays_11',
    'insectDegreeDays_12',
    'insectDegreeDays_13',
    'insectDegreeDays_14',
    'insectDegreeDays_15',
    'insectDegreeDays_16',
    'insectDegreeDays_17',
    'insectDegreeDays_18',
    'insectDegreeDays_19',
    'insectDegreeDays_20',
    'insectDegreeDays_23',
    'insectDegreeDays_24',
    'insectDegreeDays_25',
    'insectDegreeDays_26',
    'insectDegreeDays_27',
    'insectDegreeDays_28',
    'insectDegreeDays_29',
    'insectDegreeDays_30',
    'insectDegreeDaysCumulativeSinceBiofix_1',
    'insectDegreeDaysCumulativeSinceBiofix_2',
    'insectDegreeDaysCumulativeSinceBiofix_3',
    'insectDegreeDaysCumulativeSinceBiofix_4',
    'insectDegreeDaysCumulativeSinceBiofix_6',
    'insectDegreeDaysCumulativeSinceBiofix_7',
    'insectDegreeDaysCumulativeSinceBiofix_8',
    'insectDegreeDaysCumulativeSinceBiofix_9',
    'insectDegreeDaysCumulativeSinceBiofix_10',
    'insectDegreeDaysCumulativeSinceBiofix_11',
    'insectDegreeDaysCumulativeSinceBiofix_12',
    'insectDegreeDaysCumulativeSinceBiofix_13',
    'insectDegreeDaysCumulativeSinceBiofix_14',
    'insectDegreeDaysCumulativeSinceBiofix_15',
    'insectDegreeDaysCumulativeSinceBiofix_16',
    'insectDegreeDaysCumulativeSinceBiofix_17',
    'insectDegreeDaysCumulativeSinceBiofix_18',
    'insectDegreeDaysCumulativeSinceBiofix_19',
    'insectDegreeDaysCumulativeSinceBiofix_20',
    'insectDegreeDaysCumulativeSinceBiofix_23',
    'insectDegreeDaysCumulativeSinceBiofix_24',
    'insectDegreeDaysCumulativeSinceBiofix_25',
    'insectDegreeDaysCumulativeSinceBiofix_26',
    'insectDegreeDaysCumulativeSinceBiofix_27',
    'insectDegreeDaysCumulativeSinceBiofix_28',
    'insectDegreeDaysCumulativeSinceBiofix_29',
    'insectDegreeDaysCumulativeSinceBiofix_30',
    'insectTrapCatches_1',
    'insectTrapCatches_2',
    'insectTrapCatches_6',
    'insectTrapCatches_7',
    'insectTrapCatches_9',
    'insectTrapCatches_10',
    'insectTrapCatches_11',
    'insectTrapCatches_12',
    'insectTrapCatches_15',
    'insectTrapCatches_16',
    'insectTrapCatches_17',
    'insectTrapCatches_19',
    'insectTrapCatches_20',
    'insectTrapCatches_25',
    'insectTrapCatches_27',
    'insectTrapCatches_28',
    'insectTrapCatches_29',
    'insectTrapCatches_30',
    'insectTrapCatchesPercentage_1',
    'insectTrapCatchesPercentage_2',
    'insectTrapCatchesPercentage_6',
    'insectTrapCatchesPercentage_7',
    'insectTrapCatchesPercentage_9',
    'insectTrapCatchesPercentage_10',
    'insectTrapCatchesPercentage_11',
    'insectTrapCatchesPercentage_12',
    'insectTrapCatchesPercentage_15',
    'insectTrapCatchesPercentage_16',
    'insectTrapCatchesPercentage_17',
    'insectTrapCatchesPercentage_19',
    'insectTrapCatchesPercentage_20',
    'insectTrapCatchesPercentage_25',
    'insectTrapCatchesPercentage_27',
    'insectTrapCatchesPercentage_28',
    'insectTrapCatchesPercentage_29',
    'insectTrapCatchesPercentage_30',
    'leafWetnessHours',
    'precipitation',
    'temperature_IN',
    'wetBulb_IN',
    'windDirection',
    'windSpeed',
]);
//# sourceMappingURL=generatedEnums.js.map